"use client";
import dynamic from "next/dynamic";

const ScrollGrain = dynamic(
  () => import("@/components/ScrollGrain").then((m) => ({ default: m.ScrollGrain })),
  { ssr: false }
);

export function ScrollGrainLoader() {
  return <ScrollGrain />;
}
